import { createStore } from 'vuex'

export default createStore({
  state: {
    menu: [
      { main_menu: 0 },
      { active_menu: 0 },
      { data: [] },
      { menu_key_index: {} },
      { current_menu_key_index: 0 },
    ],
    toolbar_tab: [],
    active_tab: 0,
  },
  mutations: {
    /**
     * 刷新当前页面
     * @param {*} state 
     */
    refresh_current_page(state) {

      if (typeof state.menu.active_menu == "undefined") {
        state.menu.active_menu = "0";
        state.menu.menu_key_index = {};
        state.menu.menu_key_index[0] = 1;
      }

      state.menu.menu_key_index[state.menu.active_menu]++;
      state.menu.current_menu_key_index = state.menu.menu_key_index[state.menu.active_menu];
    },

    /**
     * 设置当前活动的菜单项 - 左侧菜单
     * @param {菜单menuindex} menu_id 
     * @param {菜单数据} menu 
     */
    set_active_menu(state, menu) {
      setTimeout(() => {
        // console.log(state, menu, menu.id);

        state.menu.active_menu = menu.id;
        state.menu.data = menu;
        if (menu.id == 0) {
          state.menu.current_menu_key_index = state.menu.menu_key_index[menu.id];
        } else {
          state.menu.current_menu_key_index = 0;
        }

        // console.log(state, menu, menu.id);
      }, 100);
    },

    /**
     * 设置当前展开的主菜单 - 左侧菜单
     * @param {主菜单的menuindex} menuindex 
     */
    set_main_menu(state, menuindex) {
      state.menu.main_menu = menuindex;
    },

    /**
     * 增加状态栏tab
     * @param {tab数据} tab 
     */
    add_toolbar_tab(state, tab) {
      // 已经存在时，直接跳转，不存在时，新增

      let is_exist = false;
      state.toolbar_tab.forEach(function (val, index, arr) {
        if (val.id == tab.id) {
          is_exist = true;
        }
      });

      if (!is_exist) {
        // 不存在，插入
        state.toolbar_tab.push(tab);

        if (typeof (state.menu.menu_key_index) == "undefined") {
          state.menu.menu_key_index = new Array();
        }

        // 计算menu_key_index值，如果未有，以1开始，如果有，++
        if (state.menu.menu_key_index.hasOwnProperty(tab.id) == false) {
          state.menu.menu_key_index[tab.id] = 1;
        } else {
          state.menu.menu_key_index[tab.id]++;
        }
      }

      state.active_tab = tab.id;
      // console.log(tab.id);
    },

    delete_toolbar_tab(state, tab_id) {
      let new_index = 0;

      try {
        state.toolbar_tab.forEach(function (val, index, arr) {
          if (val.id == tab_id) {
            // 删除当前tab
            if (val.id == state.active_tab) {
              if (state.toolbar_tab.length == index) { // 最后一个元素，向前移动
                new_index = index - 1;
              } else { // 如果非最后一个元素，使用当前下标
                new_index = index;
              }
            } else { // 删除其他tab
              state.toolbar_tab.forEach(function (same_val, same_index) {
                if (state.active_tab == same_val.id) {
                  new_index = same_index;

                  return;
                }
              })
            }

            state.toolbar_tab.splice(index, 1);

            if (new_index >= state.toolbar_tab.length) {
              new_index = state.toolbar_tab.length - 1
            }

            // 设置左侧菜单为选中
            setTimeout(() => {
              if (state.toolbar_tab.length > 0) {
                state.menu.active_menu = state.toolbar_tab[new_index].id;
                state.menu.data = state.toolbar_tab[new_index];
              } else {
                state.menu.active_menu = 0;
                state.menu.data = {};
              }
            }, 100);

            // 设置toolbar为选中
            setTimeout(() => {
              if (state.toolbar_tab.length > 0) {
                state.active_tab = state.toolbar_tab[new_index].id;
                state.menu.main_menu = state.toolbar_tab[new_index].parent_key;
              } else {
                state.active_tab = 0;
                state.menu.main_menu = 0;
              }
            }, 100);

            // 当全部tab被关闭后，初始化菜单状态
            if (state.toolbar_tab.length == 0) {
              state.menu.main_menu = 0;
              state.menu.active_menu = 0;
            }
            return;
          }
        });
      } catch (error) {
        state.menu.main_menu = 0;
        state.menu.active_menu = 0;
      }
    },

    delete_toolbar_tab_left(state, tab_id) {
      let new_index = 0;

      try {
        state.toolbar_tab.forEach(function (val, index, arr) {
          if (val.id < tab_id) {
            // 删除当前tab
            // if (val.id == state.active_tab) {
            //   if (state.toolbar_tab.length == index) { // 最后一个元素，向前移动
            //     new_index = index - 1;
            //   } else { // 如果非最后一个元素，使用当前下标
            //     new_index = index;
            //   }
            // } else { // 删除其他tab
            state.toolbar_tab.forEach(function (same_val, same_index) {
              if (state.active_tab == same_val.id) {
                new_index = same_index;

                return;
              }
            })
            // }

            state.toolbar_tab.splice(index, 1);

            if (new_index >= state.toolbar_tab.length) {
              new_index = state.toolbar_tab.length - 1
            }

            // 设置左侧菜单为选中
            setTimeout(() => {
              if (state.toolbar_tab.length > 0) {
                state.menu.active_menu = state.toolbar_tab[new_index].id;
                state.menu.data = state.toolbar_tab[new_index];
              } else {
                state.menu.active_menu = 0;
                state.menu.data = {};
              }
            }, 100);

            // 设置toolbar为选中
            setTimeout(() => {
              if (state.toolbar_tab.length > 0) {
                state.active_tab = state.toolbar_tab[new_index].id;
                state.menu.main_menu = state.toolbar_tab[new_index].parent_key;
              } else {
                state.active_tab = 0;
                state.menu.main_menu = 0;
              }
            }, 100);

            // 当全部tab被关闭后，初始化菜单状态
            if (state.toolbar_tab.length == 0) {
              state.menu.main_menu = 0;
              state.menu.active_menu = 0;
            }
            // return;
          }
        });
        return;
      } catch (error) {
        state.menu.main_menu = 0;
        state.menu.active_menu = 0;
      }
    },

    delete_toolbar_tab_right(state, tab_id) {
      let new_index = 0;

      try {
        state.toolbar_tab.forEach(function (val, index, arr) {
          if (val.id < tab_id) {
            // 删除当前tab
            // if (val.id == state.active_tab) {
            //   if (state.toolbar_tab.length == index) { // 最后一个元素，向前移动
            //     new_index = index - 1;
            //   } else { // 如果非最后一个元素，使用当前下标
            //     new_index = index;
            //   }
            // } else { // 删除其他tab
            state.toolbar_tab.forEach(function (same_val, same_index) {
              if (state.active_tab == same_val.id) {
                new_index = same_index;

                return;
              }
            })
            // }

            state.toolbar_tab.splice(index, 1);

            if (new_index >= state.toolbar_tab.length) {
              new_index = state.toolbar_tab.length - 1
            }

            // 设置左侧菜单为选中
            setTimeout(() => {
              if (state.toolbar_tab.length > 0) {
                state.menu.active_menu = state.toolbar_tab[new_index].id;
                state.menu.data = state.toolbar_tab[new_index];
              } else {
                state.menu.active_menu = 0;
                state.menu.data = {};
              }
            }, 100);

            // 设置toolbar为选中
            setTimeout(() => {
              if (state.toolbar_tab.length > 0) {
                state.active_tab = state.toolbar_tab[new_index].id;
                state.menu.main_menu = state.toolbar_tab[new_index].parent_key;
              } else {
                state.active_tab = 0;
                state.menu.main_menu = 0;
              }
            }, 100);

            // 当全部tab被关闭后，初始化菜单状态
            if (state.toolbar_tab.length == 0) {
              state.menu.main_menu = 0;
              state.menu.active_menu = 0;
            }
            // return;
          }
        });
        return;
      } catch (error) {
        state.menu.main_menu = 0;
        state.menu.active_menu = 0;
      }
    },

    delete_toolbar_tab_other(state, tab_id) {
      let new_index = 0;

      // console.log(state.toolbar_tab);

      state.toolbar_tab.forEach(function (val, index, arr) {
        if (val.id != state.active_tab) {
          state.toolbar_tab.splice(index, 1);
        }
      })

      state.toolbar_tab.forEach(function (val, index, arr) {
        if (val.id != state.active_tab) {
          state.toolbar_tab.splice(index, 1);
        }
      })

      // try {
      //   state.toolbar_tab.forEach(function (val, index, arr) {
      //     if (val.id < tab_id) {
      //       // 删除当前tab
      //       if (val.id == state.active_tab) {
      //         if (state.toolbar_tab.length == index) { // 最后一个元素，向前移动
      //           new_index = index - 1;
      //         } else { // 如果非最后一个元素，使用当前下标
      //           new_index = index;
      //         }
      //       } else { // 删除其他tab
      //         state.toolbar_tab.forEach(function (same_val, same_index) {
      //           if (state.active_tab == same_val.id) {
      //             new_index = same_index;

      //             // return;
      //           }
      //         })
      //       }

      //       state.toolbar_tab.splice(index, 1);

      //       if (new_index >= state.toolbar_tab.length) {
      //         new_index = state.toolbar_tab.length - 1
      //       }

      //       // 设置左侧菜单为选中
      //       setTimeout(() => {
      //         if (state.toolbar_tab.length > 0) {
      //           state.menu.active_menu = state.toolbar_tab[new_index].id;
      //           state.menu.data = state.toolbar_tab[new_index];
      //         } else {
      //           state.menu.active_menu = 0;
      //           state.menu.data = {};
      //         }
      //       }, 100);

      //       // 设置toolbar为选中
      //       setTimeout(() => {
      //         if (state.toolbar_tab.length > 0) {
      //           state.active_tab = state.toolbar_tab[new_index].id;
      //           state.menu.main_menu = state.toolbar_tab[new_index].parent_key;
      //         } else {
      //           state.active_tab = 0;
      //           state.menu.main_menu = 0;
      //         }
      //       }, 100);

      //       // 当全部tab被关闭后，初始化菜单状态
      //       if (state.toolbar_tab.length == 0) {
      //         state.menu.main_menu = 0;
      //         state.menu.active_menu = 0;
      //       }
      //       // return;
      //     }
      //   });
      //   // return;
      // } catch (error) {
      //   state.menu.main_menu = 0;
      //   state.menu.active_menu = 0;
      // }
    },

    delete_toolbar_all(state) {
      state.toolbar_tab = [];

      // 设置左侧菜单为选中
      setTimeout(() => {
        state.menu.active_menu = 0;
        state.menu.data = {};
      }, 100);

      // 设置toolbar为选中
      setTimeout(() => {
        state.active_tab = 0;
        state.menu.main_menu = 0;
      }, 100);

      // 当全部tab被关闭后，初始化菜单状态
      state.menu.main_menu = 0;
      state.menu.active_menu = 0;

      // state.menu = [
      //   { main_menu: 0 },
      //   { active_menu: 0 },
      //   { data: [] },
      //   { menu_key_index: {} },
      //   { current_menu_key_index: 0 },
      // ]
      // state.toolbar_tab = [];
      // state.active_tab = 0;
    },
  },
  actions: {
  },
  modules: {
  }
})
